import { combineReducers } from 'redux';
import { headcountTrendReducer } from 'Reducers/HeadcountTrend';
import { headcountActiveEmployeeCSVReducer } from 'Reducers/HeadcountActiveEmployeeCSV';
import { headcountBreakdownReducer } from 'Reducers/HeadcountBreakdown';
import { headcountBreakdownCSVReducer } from 'Reducers/HeadcountBreakdownCSV';
import { headcountTotalEmployeeReducer } from 'Reducers/HeadcountTotalEmployee';
import { headcountNewJoinerReducer } from 'Reducers/HeadcountNewJoiner';
import { headcountHrRatioReducer } from 'Reducers/HeadcountHrRatio';
import { headcountLeavingReducer } from 'Reducers/HeadcountLeaving';
import { headcountTurnoverReducer } from 'Reducers/HeadcountTurnover';
import { headcountOrganizationReducer } from 'Reducers/HeadcountOrganization';
import { headcountJoblevelReducer } from 'Reducers/HeadcountJoblevel';
import { headcountServiceLengthReducer } from 'Reducers/HeadcountServiceLength';
import { headcountServiceLengthCSVReducer } from "Reducers/HeadcountServiceLengthCSV";
import { headcountResignJoinReducer } from 'Reducers/HeadcountResignJoin';
import { headcountResignJoinCSVReducer } from 'Reducers/HeadcountResignJoinCSV';
import { headcountTurnoverGenderReducer } from 'Reducers/HeadcountTurnoverGender';
import { headcountTurnoverEducationReducer } from 'Reducers/HeadcountTurnOverEducation';
import { headcountTurnoverAgeReducer } from 'Reducers/HeadcountTurnoverAge';
import { headcountTurnoverVoluntaryReducer } from 'Reducers/HeadcountTurnoverVoluntary';
import { headcountTurnoverWorksPeriodReducer } from 'Reducers/HeadcountTurnoverWorksPeriod';
import { headcountResignReasonReducer } from 'Reducers/HeadcountResignReason';
import { headcountResignReasonCSVReducer } from "Reducers/HeadcountResignReasonCSV";
import { headcountReprimandHistoryReducer } from 'Reducers/HeadcountReprimandHistory';

import { cnameReducer } from 'Reducers/Cname';
import { headcountNewJoinerCSVReducer } from "Reducers/HeadcountNewJoinerCSV";
import { headcountLeavingEmployeeCSVReducer } from "Reducers/HeadcountLeavingEmployeeCSV";
import { filterBrancheReducer } from 'Reducers/FilterBranches';
import { filterBranchGlobalReducer } from 'Reducers/FilterBranchGlobal';
import { filterOrganizationReducer } from 'Reducers/FilterOrganization';
import { filterOrganizationGlobalReducer } from 'Reducers/FilterOrganizationGlobal';
import { filterJobPositionReducer } from 'Reducers/FilterJobPosition';
import { attendanceRecordReducer } from 'Reducers/AttendanceRecord';
import { employeeAttendanceReducer } from 'Reducers/AttendanceEmployee';
import { attendanceEmployeeModalReducer } from 'Reducers/AttendanceEmployeeModal';
import { attendanceTimeoffReducer } from 'Reducers/AttendanceTimeoff';
import { attendanceTimeoffModalReducer } from 'Reducers/AttendanceTimeoffModal';
import { attendanceTimeOffTrendsReducer } from 'Reducers/AttendanceTimeOffTrends';
import { attendanceMetricsReducer } from 'Reducers/AttendanceMetrics';
import { attendanceMetricsTypeReducer } from 'Reducers/AttendanceMetricsType';
import { lastUpdateReducer } from 'Reducers/LastUpdate';
import { jobPositionReducer } from 'Reducers/JobPosition';
import { AttritionsOverviewReducer } from 'Reducers/AttritionsOverview';
import { attritionsOverviewByFilterReducer } from 'Reducers/AttritionsOverviewByFilter';
import { attritionsOverviewByEmployeeReducer } from 'Reducers/AttritionsOverviewByEmployee';
import { headcountReprimandTrendCSVReducer } from './HeadcountReprimandTrendCSV';
import { filterJobPositionModalReducer } from './FilterJobPositionModal';
import { currentUserReducer } from './CurrentUser';
import { checkAuthReducer } from './CheckAuth';
import { reportBuilderAuthReducer } from './ReportBuilderAuth';
import { signOutReducer } from './SignOut';
import { headcountTurnoverBreakdownCSVReducer } from "./HeadcountTurnoverBreakdownCSV";
import { headcountEmployeeTransferReducer } from "./HeadcountEmployeeTransfer";
import { headcountEmployeeTransferCSVReducer } from "./HeadcountEmployeeTransferCSV";
import { exportHistoryReducer } from './ExportHistory';

const rootReducers = combineReducers({
  headcountTrend: headcountTrendReducer,
  headcountBreakdown: headcountBreakdownReducer,
  headcountEmployeeTransfer: headcountEmployeeTransferReducer,
  headcountEmployeeTransferCSV: headcountEmployeeTransferCSVReducer,
  headcountBreakdownCSV: headcountBreakdownCSVReducer,
  headcountActiveEmployeeCSV: headcountActiveEmployeeCSVReducer,
  headcountTotalEmployee: headcountTotalEmployeeReducer,
  headcountNewJoiner: headcountNewJoinerReducer,
  headcountNewJoinerCSV: headcountNewJoinerCSVReducer,
  headcountLeavingEmployeeCSV: headcountLeavingEmployeeCSVReducer,
  headcountHrRatio: headcountHrRatioReducer,
  headcountLeaving: headcountLeavingReducer,
  headcountTurnover: headcountTurnoverReducer,
  headcountTurnoverEducation: headcountTurnoverEducationReducer,
  headcountTurnoverGender: headcountTurnoverGenderReducer,
  headcountTurnoverAge: headcountTurnoverAgeReducer,
  headcountTurnoverVoluntary: headcountTurnoverVoluntaryReducer,
  headcountTurnoverWorksPeriod: headcountTurnoverWorksPeriodReducer,
  headcountTurnoverBreakdownCSV: headcountTurnoverBreakdownCSVReducer,
  headcountOrganization: headcountOrganizationReducer,
  headcountJoblevel: headcountJoblevelReducer,
  headcountServiceLength: headcountServiceLengthReducer,
  headcountServiceLengthCSV: headcountServiceLengthCSVReducer,
  cname: cnameReducer,
  headcountResignJoin: headcountResignJoinReducer,
  headcountResignJoinCSV: headcountResignJoinCSVReducer,
  headcountResignReason: headcountResignReasonReducer,
  headcountResignReasonCSV: headcountResignReasonCSVReducer,
  headcountReprimandHistory: headcountReprimandHistoryReducer,
  headcountReprimandTrendCSV: headcountReprimandTrendCSVReducer,
  filterBranch: filterBrancheReducer,
  filterBranchGlobal: filterBranchGlobalReducer,
  filterOrganization: filterOrganizationReducer,
  filterOrganizationGlobal: filterOrganizationGlobalReducer,
  filterJobPosition: filterJobPositionReducer,
  filterJobPositionModal: filterJobPositionModalReducer,
  attendanceRecord: attendanceRecordReducer,
  employeeAttendanceRecord: employeeAttendanceReducer,
  attendanceEmployeeModal: attendanceEmployeeModalReducer,
  attendanceTimeoff: attendanceTimeoffReducer,
  attendanceTimeoffModal: attendanceTimeoffModalReducer,
  attendanceTimeOffTrends: attendanceTimeOffTrendsReducer,
  attendanceMetrics: attendanceMetricsReducer,
  attendanceMetricsType: attendanceMetricsTypeReducer,
  lastUpdate: lastUpdateReducer,
  jobPosition: jobPositionReducer,
  attritionsOverview: AttritionsOverviewReducer,
  attritionsOverviewByFilter: attritionsOverviewByFilterReducer,
  attritionsOverviewByEmployee: attritionsOverviewByEmployeeReducer,
  currentUser: currentUserReducer,
  checkAuth: checkAuthReducer,
  reportBuilderAuth: reportBuilderAuthReducer,
  signOut: signOutReducer,
  exportHistory: exportHistoryReducer
});

export default rootReducers;
